import * as React from 'react';

import { NumberField, cn } from '@rematter/ui-web';

export interface PriceFieldCellProps {
  value: number;
  onChange?: (value: number) => void;
  disabled?: boolean;
  minValue?: number;
  prefix?: string;
  suffix?: string;
  className?: string;
  formatOptions?: Intl.NumberFormatOptions;
  errorMessage?: string;
  isInvalid?: boolean;
}

const DEFAULT_FORMAT_OPTIONS: Intl.NumberFormatOptions = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

export const PriceFieldCell: React.FC<PriceFieldCellProps> = ({
  value,
  onChange,
  disabled = false,
  minValue = 0,
  prefix = '$',
  suffix,
  className,
  formatOptions = DEFAULT_FORMAT_OPTIONS,
  errorMessage,
  isInvalid,
}) => (
  <NumberField
    value={value}
    onChange={onChange}
    isDisabled={disabled}
    minValue={minValue}
    showSteppers={false}
    prefix={prefix}
    suffix={suffix}
    formatOptions={formatOptions}
    errorMessage={errorMessage}
    isInvalid={isInvalid}
    className={cn('@PriceFieldCell', className)}
  />
);
